import axios from "axios";
import { API_BASE_URL } from "../utils/apiConfig";

export interface AccessRequestItem {
  id: number;
  user: number;
  user_username: string;
  user_email?: string;
  user_name?: string;
  status: string;
  requested_at: string;
  ip_address?: string;
  browser?: string;
  os?: string;
  is_new_device?: boolean;
  is_new_ip?: boolean;
  attempted_at?: string;
}

export interface GetAccessRequestsParams {
  status?: "pending" | "approved" | "denied";
}

/**
 * Lista wniosków o dostęp (wymaga users.view).
 * GET /api/access-requests/
 */
const getAccessRequests = async (
  params?: GetAccessRequestsParams
): Promise<AccessRequestItem[]> => {
  const queryParams = new URLSearchParams();
  if (params?.status) {
    queryParams.append("status", params.status);
  }
  const queryString = queryParams.toString();
  const url = `${API_BASE_URL}/access-requests/${queryString ? `?${queryString}` : ""}`;
  const { data } = await axios.get<AccessRequestItem[]>(url);
  return Array.isArray(data) ? data : (data as any)?.results ?? [];
};

/**
 * Zatwierdzenie wniosku o dostęp.
 * POST /api/access-requests/{id}/approve/
 */
const approveAccessRequest = async (id: number): Promise<void> => {
  await axios.post(`${API_BASE_URL}/access-requests/${id}/approve/`, {});
};

/**
 * Odrzucenie wniosku o dostęp.
 * POST /api/access-requests/{id}/deny/
 */
const denyAccessRequest = async (
  id: number,
  review_notes?: string
): Promise<void> => {
  await axios.post(`${API_BASE_URL}/access-requests/${id}/deny/`, {
    review_notes: review_notes || "",
  });
};

export const accessRequestsApi = {
  getAccessRequests,
  approveAccessRequest,
  denyAccessRequest,
};
